import { useState, useEffect } from "react";
import { GoogleOAuthProvider, useGoogleOneTapLogin, googleLogout } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { googleOneTapAPI } from "../../Services/authService";
import { useHistory } from "react-router-dom";
import useAuthStore from "../../Store/AuthStore";
import { fetchAndSendSavedProductsToApi } from "../../Utils/ProductUtil.jsx";
import { encodeSearchText } from "../../Utils/urlEncoder.js";

export default function GoogleOneTapLogin() {
  const history = useHistory();
  const { login, isAuthenticated } = useAuthStore(); // Get isLoggedIn from store
  const [hasHydrated, setHasHydrated] = useState(false);

  useEffect(() => {
    const unsubscribe = useAuthStore.persist.onFinishHydration(() => {
      setHasHydrated(true);
    });
    return () => unsubscribe();
  }, []);

  const handleGoogleLogin = async (credential) => {
    try {
      const userData = jwtDecode(credential);
      const apiResponse = await googleOneTapAPI(credential);

      if (apiResponse.status === 200) {
        const { token, email } = apiResponse.data;
        window.localStorage.setItem("token", token);
        window.localStorage.setItem("email", email);
        window.localStorage.setItem("loggedin", JSON.stringify(true));
        fetchAndSendSavedProductsToApi();
        const finalUserData = apiResponse.data.userData || userData;
        await login(email, token, apiResponse.data.isNewUser || false, finalUserData);

        // Check if we have a stored search query from an unauthenticated user
        const unauthUserSearchText = localStorage.getItem("unauthUserSearchText");
        if (unauthUserSearchText) {
          // Use the already encoded search text
          const encodedSearchText = encodeSearchText(unauthUserSearchText);
          history.push(`/search?query=${encodedSearchText}`);
        } else {
          history.push("/search");
        }
      }
    } catch (error) {
      console.error("Login Error:", error);
    }
  };

  useGoogleOneTapLogin({
    onSuccess: (credentialResponse) => {
      if (credentialResponse.credential) {
        handleGoogleLogin(credentialResponse.credential);
      }
    },
    onError: () => console.log("Login Failed"),
    disabled: isAuthenticated, // Disable when logged in
    auto_select: false,
    cancel_on_tap_outside: true,
    context: "signin"
  });

  return null;
}